/* Shirts Frenzy — AJAX cart drawer. Opens on cart-icon click + add-to-cart,
   renders from /cart.js, qty/remove via /cart/change.js. */
(function () {
  var drawer = document.getElementById('sf-cart');
  if (!drawer) return;
  var content = drawer.querySelector('[data-sf-cart-content]');
  var SYM = drawer.getAttribute('data-currency') || '$';

  var CART = '<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><circle cx="9" cy="20" r="1.4"/><circle cx="18" cy="20" r="1.4"/><path d="M2.5 4H5l2.1 10.4a1.3 1.3 0 0 0 1.3 1.1h8.4a1.3 1.3 0 0 0 1.3-1.1L21 7.5H6"/></svg>';
  var X = '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="1.6"><path d="m5 5 14 14M19 5 5 19"/></svg>';
  var MINUS = '<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="1.8"><path d="M5 12h14"/></svg>';
  var PLUS = '<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="1.8"><path d="M12 5v14M5 12h14"/></svg>';
  var ARROW = '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="1.8"><path d="M5 12h14M13 6l6 6-6 6"/></svg>';

  function money(c) { return SYM + (c / 100).toFixed(2); }
  function esc(s) { var d = document.createElement('div'); d.textContent = s == null ? '' : s; return d.innerHTML; }

  function open() { drawer.classList.add('open'); drawer.setAttribute('aria-hidden', 'false'); document.body.style.overflow = 'hidden'; refresh(); }
  function close() { drawer.classList.remove('open'); drawer.setAttribute('aria-hidden', 'true'); document.body.style.overflow = ''; }

  function setCount(n) {
    var cart = document.querySelector('.nav-cart');
    if (cart) {
      var b = cart.querySelector('.nav-cart-count');
      if (n > 0) { if (!b) { b = document.createElement('span'); b.className = 'nav-cart-count'; cart.appendChild(b); } b.textContent = n; }
      else if (b) { b.remove(); }
    }
    drawer.querySelectorAll('[data-sf-cart-count]').forEach(function (e) { e.textContent = '(' + n + ')'; });
  }

  function render(cart) {
    setCount(cart.item_count);
    if (cart.item_count === 0) {
      content.innerHTML = '<div class="cart-body thin-scroll"><div class="cart-empty"><div class="cart-empty-mark">' + CART + '</div><p class="mono">Your cart is empty.</p><a class="btn btn-ink" href="/collections/all">Shop the drops</a></div></div>';
      return;
    }
    var lines = cart.items.map(function (it) {
      var opts = (it.options_with_values || []).map(function (o) { return esc(o.value); }).join(' · ') || esc(it.variant_title) || '';
      var img = (it.featured_image && it.featured_image.url) ? '<img src="' + it.featured_image.url + '&width=160" alt="">' : '';
      return '<div class="cart-line" data-key="' + it.key + '">'
        + '<div class="pimg cart-thumb" data-sf-cart-image-slot data-product-id="' + it.product_id + '" data-variant-id="' + it.variant_id + '">' + img + '</div>'
        + '<div class="cart-line-info"><div class="cart-line-top"><span class="cart-line-name">' + esc(it.product_title) + '</span>'
        + '<button class="cart-x" data-remove aria-label="Remove">' + X + '</button></div>'
        + '<div class="cart-line-var mono">' + opts + '</div>'
        + '<div class="cart-line-bot"><div class="qty"><button data-dec aria-label="Less">' + MINUS + '</button>'
        + '<span class="mono">' + it.quantity + '</span><button data-inc aria-label="More">' + PLUS + '</button></div>'
        + '<span class="mono cart-line-price">' + money(it.final_line_price) + '</span></div></div></div>';
    }).join('');
    var foot = '<div class="cart-foot"><div class="cart-sub"><span class="mono">Subtotal</span><span class="display cart-sub-amt">' + money(cart.total_price) + '</span></div>'
      + '<p class="cart-note mono">Taxes &amp; fees handled on our side — the price you see is what you pay.</p>'
      + '<a class="btn btn-primary btn-lg btn-block" href="/checkout">Checkout ' + ARROW + '</a></div>';
    content.innerHTML = '<div class="cart-body thin-scroll">' + lines + '</div>' + foot;
    if (window.SFR2Cart) window.SFR2Cart.enhance(content);
  }

  function refresh() { fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(render); }
  function change(key, qty) {
    fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: key, quantity: qty }) })
      .then(function (r) { return r.json(); }).then(render);
  }

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-sf-cart-open]')) { e.preventDefault(); open(); return; }
    if (e.target.closest('[data-sf-cart-close]')) { e.preventDefault(); close(); return; }
    var line = e.target.closest('.cart-line');
    if (line && drawer.contains(line)) {
      var key = line.getAttribute('data-key');
      var cur = parseInt(line.querySelector('.qty span').textContent, 10);
      if (e.target.closest('[data-inc]')) change(key, cur + 1);
      else if (e.target.closest('[data-dec]')) change(key, cur - 1);
      else if (e.target.closest('[data-remove]')) change(key, 0);
    }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
  // tap/click anywhere outside the panel closes the cart (pointerdown is reliable on iOS,
  // unlike a backdrop click) — no close button needed.
  document.addEventListener('pointerdown', function (e) {
    if (!drawer.classList.contains('open')) return;
    if (e.target.closest('.cart-panel') || e.target.closest('[data-sf-cart-open]')) return;
    close();
  });

  var pform = document.getElementById('sf-product-form');
  if (pform) {
    pform.addEventListener('submit', function (e) {
      e.preventDefault();
      var btn = pform.querySelector('[type=submit]');
      var variant = pform.querySelector('[name=id]');
      if (!variant || variant.disabled || !variant.value || (btn && btn.disabled)) return;
      if (btn) btn.disabled = true;
      fetch('/cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(pform) })
        .then(function (r) { if (!r.ok) throw r; return r.json(); })
        .then(function () { if (btn) btn.disabled = variant.disabled || !variant.value; open(); })
        .catch(function () {
          if (btn) btn.disabled = variant.disabled || !variant.value;
          if (!variant.disabled && variant.value) pform.submit();
        });
    });
  }
})();

/* Mobile menu — close on tap/click anywhere outside the panel (iOS-reliable pointerdown), so no
   close button is needed. Kept here in a real asset because the header's section JavaScript bundle
   doesn't reliably hot-reload under theme dev; the burger still opens it via the header's own JS. */
(function () {
  var mm = document.getElementById('sf-mm');
  if (!mm) return;
  document.addEventListener('pointerdown', function (e) {
    if (!mm.classList.contains('open')) return;
    if (e.target.closest('.mm-panel') || e.target.closest('[data-sf-menu-open]')) return;
    mm.classList.remove('open');
    mm.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  });
})();

/* Collection filter slide-out (mobile/narrow) — close on tap/click outside the panel, same as the
   menu/cart/search. The "Filters" button still opens it via the collection section's own JS. */
(function () {
  var side = document.getElementById('sf-side');
  if (!side) return;
  document.addEventListener('pointerdown', function (e) {
    if (!side.classList.contains('open')) return;
    if (e.target.closest('.cat-side-panel') || e.target.closest('[data-sf-side-open]')) return;
    side.classList.remove('open');
    document.body.style.overflow = '';
  });
})();

/* Side-menu "Your design" suggestion box.
   Submits NATIVELY into a hidden iframe (#sf-design-sink) — the exact same path the
   working contact-page form uses, so Shopify actually delivers the email — while the
   page (and the open menu) stay put. A scripted fetch() POST was NOT being delivered
   by Shopify; the native form submit is. Success is confirmed from Shopify's own
   `contact_posted=true` redirect that lands in the iframe. HTML5 `required` validation
   runs before submit, so the submit event only fires on a valid form. */
(function () {
  var form = document.getElementById('sf-design-form');
  var sink = document.getElementById('sf-design-sink');
  if (!form) return;
  var submitting = false;
  form.addEventListener('submit', function () {
    submitting = true;
    var oldErr = form.querySelector('.mm-design-err'); if (oldErr) oldErr.remove();
    var btn = form.querySelector('[type=submit]'); if (btn) btn.disabled = true;
    // do NOT preventDefault — let the native submit post into the iframe
  });
  if (sink) {
    sink.addEventListener('load', function () {
      if (!submitting) return;              // ignore the initial blank iframe load
      submitting = false;
      var ok = true;                        // same-origin → confirm Shopify accepted it
      try {
        var href = sink.contentWindow.location.href;
        if (href && href.indexOf('about:blank') === -1) ok = /contact_posted=true/.test(href);
      } catch (e) { ok = true; }            // cross-origin (shouldn't happen) → assume sent
      if (ok) {
        form.innerHTML = '<p class="mm-design-sent mono">✦ Thanks — idea received. Keep an eye on the drops.</p>';
      } else {
        var btn = form.querySelector('[type=submit]'); if (btn) btn.disabled = false;
        var er = document.createElement('p'); er.className = 'mm-design-err mono';
        er.textContent = "✕ Couldn't send — please try again.";
        form.appendChild(er);
      }
    });
  }
})();
